import React from 'react';
import classnames from 'classnames';
import { EXPANDED_THEME_VALUES } from '@wix/wix-vod-constants/app-settings';
import styles from './item-loading.scss';
export class ItemLoading extends React.Component {
    render() {
        const { theme, active, style } = this.props;
        return (React.createElement("div", { "data-hook": "item-loading", style: style, className: classnames(styles.container, {
                [styles.light]: theme === EXPANDED_THEME_VALUES.LIGHT,
                [styles.dark]: theme === EXPANDED_THEME_VALUES.DARK,
                [styles.universal]: !theme,
                [styles.active]: active,
            }) }));
    }
}
//# sourceMappingURL=item-loading.js.map